import { render } from "./AddCaseIncident.vue?vue&type=template&id=ac3df0a0"
import script from "./AddCaseIncident.vue?vue&type=script&lang=js"
export * from "./AddCaseIncident.vue?vue&type=script&lang=js"
script.render = render

export default script